import * as React from 'react'

import { Dots, DotsProps } from './Dots'
import { Spinner } from './Spinner'


export const Loader: {
  Spinner: React.FC<React.ComponentProps<'svg'>>
  Dots: React.FC<DotsProps>
} = {
  Spinner: Spinner,
  Dots: Dots,
}
